const ISOLATED_AUTH_KEY = 'isolatedAuth';

export const getAuthToken = (): string | null => {
  if (sessionStorage.getItem(ISOLATED_AUTH_KEY) === 'true') {
    return sessionStorage.getItem('token');
  }

  return localStorage.getItem('token');
};

export const storeAuthToken = (token: string): void => {
  if (sessionStorage.getItem(ISOLATED_AUTH_KEY) === 'true') {
    sessionStorage.setItem('token', token);
    return;
  }

  localStorage.setItem('token', token);
};

export const removeAuthToken = (): void => {
  if (sessionStorage.getItem(ISOLATED_AUTH_KEY) === 'true') {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem(ISOLATED_AUTH_KEY);
    return;
  }

  localStorage.removeItem('token');
  sessionStorage.removeItem('token');
};

export const setIsolatedAuthToken = (token: string): void => {
  sessionStorage.setItem(ISOLATED_AUTH_KEY, 'true');
  sessionStorage.setItem('token', token);
};
